import _a0 from '../assets/favicon.ico';
import _a1 from '../assets/thornless_icon.png';

const _map: Record<string, string> = {
  '/images/favicon.ico': _a0,
  'favicon.ico': _a0,
  '/images/thornless_icon.png': _a1,
  'thornless_icon.png': _a1,
};

/** Resolve an image path to a Vite-bundled URL with cache-busting hash.
 *  Falls back to the original path for remote URLs or unknown filenames. */
export function assetUrl(path: string): string {
  return _map[path] ?? path;
}
